import { render, staticRenderFns } from "./NewsIssuesList.vue?vue&type=template&id=33ec2eca"
import script from "./NewsIssuesList.js?vue&type=script&lang=js&external"
export * from "./NewsIssuesList.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports